function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M24.77 28H3.23C1.45 28 0 26.55 0 24.77V3.23C0 1.45 1.45 0 3.23 0h21.54C26.55 0 28 1.45 28 3.23v21.54c0 1.78-1.45 3.23-3.23 3.23zM14 8.62c-2.97 0-5.38 2.4-5.38 5.38s2.4 5.38 5.38 5.38 5.38-2.4 5.38-5.38c0-2.97-2.4-5.38-5.38-5.38zm10.77-4.3c0-.6-.48-1.1-1.08-1.1h-3.26c-.6 0-1.08.5-1.08 1.1v3.22c0 .6.5 1.08 1.08 1.08h3.23c.6 0 1.07-.5 1.07-1.08V4.3zm0 7.53h-2.44c.18.68.28 1.4.28 2.15 0 4.76-3.82 8.62-8.6 8.62S5.4 18.76 5.4 14c0-.74.1-1.47.3-2.15H3.22V23.7c0 .6.48 1.07 1.08 1.07h19.4c.6 0 1.07-.48 1.07-1.08V11.82z",
  className: ""
});

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.5c3db498.svg";
export { ForwardRef as ReactComponent };